import { Link } from "react-router-dom";
import { Seo, CTAButton } from "@/components/site/primitives";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="grain relative flex min-h-screen items-center bg-ink">
      <div className="hairgrid pointer-events-none absolute inset-0 opacity-40" />
      <div className="relative mx-auto max-w-[1400px] px-5 py-32 md:px-10">
        <span className="eyebrow">Error · 404</span>
        <h1 className="mt-6 font-serif text-6xl tracking-tighter text-bone md:text-8xl">
          Not in memory.
        </h1>
        <p className="mt-6 max-w-md text-lg text-mist">
          This page has no source chunk — so we abstain rather than invent one. Let's get you back.
        </p>
        <div className="mt-10 flex flex-wrap gap-4">
          <CTAButton to="/" variant="solid">Home</CTAButton>
          <CTAButton to="/smritium" variant="outline">Explore Smritium</CTAButton>
        </div>
      </div>
    </div>
  );
}
